/**
 * @file Plugin for Amplitude analytics
 * @author Dan Chen <dan.chen@homebot.ai>
 */

import { Types } from '@amplitude/analytics-browser'

export const addEventSourcePlugin = () => {
  const name = 'add-event-source'
  let amplitudeConfig

  const setup = async function (config) {
    amplitudeConfig = config
  }

  const execute = async function (event: Types.Event): Promise<Types.Event> {
    return {
      ...event,
      event_properties: {
        ...event.event_properties,
        event_source: 'cfe'
      }
    }
  }

  return {
    name,
    setup,
    execute
  }
}
